/*=====================================
    CupoyNoteContent

    Author: Gray
    CreateTime: 2020 / 04 / 15
=====================================*/

/*--------------------------
    Import
--------------------------*/
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

/*--------------------------
    Main Component
--------------------------*/
class CupoyNoteContent extends PureComponent {

    static propTypes = {
        html: PropTypes.string,
    };

    constructor(props) {

        super(props);

        this.contentRef = null;
        
        this.initRef = this.initRef.bind(this);
    }

    // ------------------------------
    // initRef
    // ------------------------------
    initRef(ref) {

        if(!ref) {
            return;
        }

        this.contentRef = ref;
        
        setTimeout(() => {
            // 將所有連結皆設為開啟新分頁
            const atags = this.contentRef.querySelectorAll('a');
            if(atags) {
                atags.forEach(item => {
                    item.setAttribute('target', '_blank');
                    item.setAttribute('rel', 'noopener noreferrer nofollow');
                });
            }
        });

    }

    // ------------------------------
    // render
    // ------------------------------
    render() {

        const {
            html,
        } = this.props;

        return (
            <div ref={this.initRef}>
                <div dangerouslySetInnerHTML={{ __html: html }} />
            </div>
        );
    }
}

/*--------------------------
    Export
--------------------------*/
export default CupoyNoteContent;